import { ApiPath } from '@common/app/api-path';
import {
  type LeaderboardData,
  type LeagueGetRewardResponseType,
  type LeagueType,
  type NewLeagueStartedType,
} from '@common/types/league';

import { api } from '../base';

const leagueApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentLeagueInfo: builder.query<LeagueType, void>({
      query: () => ApiPath.LEAGUE_INFO,
      keepUnusedDataFor: 0,
    }),
    getNewLeagueStarted: builder.query<NewLeagueStartedType, void>({
      query: () => ApiPath.LEAGUE_NEW_STARTED,
      keepUnusedDataFor: 0,
    }),
    getLeagueInfoById: builder.query<LeagueType, { leagueId: number }>({
      query: ({ leagueId }) => ApiPath.LEAGUE_INFO + `/${leagueId}`,
      keepUnusedDataFor: 0,
    }),
    getLeagueReward: builder.mutation<
      LeagueGetRewardResponseType,
      { leagueHistoryId: string }
    >({
      query: ({ leagueHistoryId }) => ({
        url: ApiPath.LEAGUE_GET_REWARD + leagueHistoryId,
        method: 'POST',
      }),
    }),
    getLeagueBoard: builder.query<LeaderboardData, void>({
      query: () => ApiPath.LEAGUE_BOARD,
      keepUnusedDataFor: 0,
    }),
  }),
});

const {
  useGetCurrentLeagueInfoQuery,
  useLazyGetLeagueInfoByIdQuery,
  useGetLeagueRewardMutation,
  useGetNewLeagueStartedQuery,
  useGetLeagueBoardQuery,
} = leagueApi;

export const useGetLeagueBoardQueryState =
  leagueApi.endpoints.getLeagueBoard.useQueryState;
export {
  leagueApi,
  useGetCurrentLeagueInfoQuery,
  useGetLeagueBoardQuery,
  useGetLeagueRewardMutation,
  useGetNewLeagueStartedQuery,
  useLazyGetLeagueInfoByIdQuery,
};
